export default __webpack_public_path__ + "static/media/deco-result3.e8e7db52.png";